export const splitFullName = (fullName: string): { firstName: string; lastName: string } => {
  const [firstName, ...rest] = fullName.trim().split(/\s+/);
  return { firstName, lastName: rest.join(' ') || firstName };
};
